import { Component } from '@angular/core';
import { NavController, NavParams,ViewController,LoadingController } from 'ionic-angular';
import { DbservicesProvider } from '../../providers/dbservices/dbservices';

@Component({
  selector: 'page-markaspaid',
  templateUrl: 'markaspaid.html',
})
export class MarkaspaidPage {

	payment;
  item;
  page;
  type;
  preparation_time_hr = '00';
  preparation_time;
  delivery_slot;
  constructor(public loadingCtrl: LoadingController,public viewCtrl: ViewController,public DBservice: DbservicesProvider,public navCtrl: NavController, public navParams: NavParams) {
    this.payment = 'cash'
    this.item = navParams.get('item')
    this.type = navParams.get('type')
    this.page = navParams.get('page')
    this.get_restaurant_preparation_time()
  }

  get_restaurant_preparation_time(){
    var orderdata = {
      business:localStorage.restaurant
    }
    this.DBservice.get_restaurant_preparation_time(orderdata)
      .then(data => {
        console.log(data);
        this.delivery_slot = data.message;
        
      }, error => {
        console.log(JSON.stringify(error.json()));
      });
  }

  get_item(item){

         var data={
         preparation_time:item.estimated_time
      }

        this.viewCtrl.dismiss(data)


  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad MarkaspaidPage');
  }

  back(){
    this.viewCtrl.dismiss();
  }

  accepted(){
    // console.log(this.preparation_time_hr)
    // console.log(this.preparation_time)
    // if(parseInt(this.preparation_time) == 0)
    //   this.DBservice.alert('Please select any one value')
    // else
    // {
    //   var data={
    //      preparation_time:String(this.preparation_time)
    //      // preparation_time_hr:String(this.preparation_time_hr)
    //   }
    //    this.viewCtrl.dismiss(data)
    // }



    if(parseInt(this.preparation_time) <= 90 && 0 < parseInt(this.preparation_time)){
      var data={
         preparation_time:String(this.preparation_time)
         // preparation_time_hr:String(this.preparation_time_hr)
      }
        this.viewCtrl.dismiss(data)
          // this.orderpicked(item,'Restaurant Accepted',data.username,'')
        }
        else{
          this.DBservice.alert('Preparation time must be greater than 0 and Preparation time must not exceed 90 mins');
          // return false;
        }
    // if()
    // this.
    // if()
  }

  select_payment(payment) {
    console.log(payment)
    this.payment = payment
  }

  changestatus(item,status){
    if(status == 'Order Completed' && item.shipping_method == 'Pickup'){
    let loader = this.loadingCtrl.create({
      spinner: 'bubbles',
      content: 'Loading Please Wait...'
    });
     loader.present();
      setTimeout(() => { 
        loader.dismiss();
      }, 3000);
    // console.log(item)
      var data ={}
      data={
        status:status,
         name:item.name
        }
      this.DBservice.update_order(data)
        .then(data => {
           this.change_status(item,status)
        }, error => {
          console.log(JSON.stringify(error.json()));
        });
      }
        else if(status == 'Order Completed' && item.shipping_method == 'Delivery'){
      let loader = this.loadingCtrl.create({
                spinner: 'bubbles',
                content: 'Loading Please Wait...'
              });
              loader.present();
              var datas = {
                name: item.name,
                status: 'Order Delivered',
              }
              this.DBservice.update_order(datas)
                .then(resdata => {
              //     console.log(data);
                  // this.navCtrl.pop()
                  setTimeout(() => {
                  var orderdata = {
                    name: item.name,
                    status: 'Order Completed'
                  }
                  this.DBservice.update_order(orderdata)
                    .then(res_data => {
                      // console.log(data);
                      if(this.page == 'close')
                        this.viewCtrl.dismiss(true);
                      else
                        this.navCtrl.pop()


                     // this.change_status(item,status)
                      
                  // this.DBservice.alert(status)

                      setTimeout(() => {
                       loader.dismiss();
                      }, 50);
                  
                      }, error => {
                        console.log(JSON.stringify(error.json()));
                      });
                  }, 50);

                  // this.navCtrl.pop()
                }, error => {
                  console.log(JSON.stringify(error.json()));
                });
                 setTimeout(() => {
                   loader.dismiss();
                }, 4000);
    }
  }

 change_status(item,status) {
   // var data={
   //    order:item.name,
   //    mode_of_payment:"Cash",
   //    amount:item.total_amount
   //    }
   //  this.DBservice.make_payment(data)
   //    .then(data => {
   //        this.navCtrl.popTo(this.navCtrl.getByIndex(0));
   //        this.DBservice.alert(status)

   //    }, error => {
   //      console.log(JSON.stringify(error.json()));
   //    });
    

  }


}



// WEBPACK FOOTER //
// ./src/pages/markaspaid/markaspaid.ts